import { useMemo } from 'react';
import { Feature } from '@sdk/common/features';

import { useGetConversations } from '@web/conversations/hooks/useGetConversations';
import usePremiumGuard from '@web/premiumGuard/usePremiumGuard';

import { filterByName, groupByType, orderByImportance } from './conversationsSidebar.utils';

export const useConversationGroups = (filterQuery: string) => {
  const { isLoading, data } = useGetConversations();

  const groups = useMemo(() => {
    if (!data) {
      return;
    }

    const conversations = Array.from(data);

    const filteredConversations = filterByName(filterQuery, conversations);
    const orderedConversations = orderByImportance(filteredConversations);
    const groups = groupByType(orderedConversations);

    return groups;
  }, [data, filterQuery]);

  return {
    isLoading,
    groups,
  };
};

export const useGroupConversationPremiumGuard = () => {
  const { getPremiumGuardConfig, tooltipRefs } = usePremiumGuard();
  const premiumGuardConfig = getPremiumGuardConfig(Feature.groupMessages);

  return {
    premiumGuardConfig,
    tooltipRefs,
    areGroupConversationsEnabled: premiumGuardConfig.hasAccess,
  };
};
